export default __webpack_public_path__ + "static/media/forestly-expl-dissect-02_DE.908ec56c.png";